import { Component } from '@angular/core'
import { BaseCellComponent } from './base-cell.component'
import { NamedDate } from 'src/app/shared/models/namedDate'
import { DateDisplayComponent } from '../../date-display/date-display.component'

export type DateCellComponentProps<D> = Readonly<{
  date: (d: D) => Date | null;
  viewAsTZ?: string
  namedDates?: NamedDate[];
  format?: string;
}>

@Component({
  imports: [DateDisplayComponent],
  styles: `
    :host {
      position: relative;
      span[app-date-display]::ng-deep {
        margin-top: 0;
      }
    }
    `,
  template: `
    @if(params.data){
      <span app-date-display 
        [value]="params.date(params.data)" 
        [namedDates]="params.namedDates" 
        [format]="params.format" 
        [viewAsTZ]="params.viewAsTZ"></span>
    }
  `,
})
export class DateCellComponent<DATA> extends BaseCellComponent<
  DATA,
  DateCellComponentProps<DATA>,
  keyof DATA
> {}
